import { ResponsiveContainer } from './ResponsiveContainer';

import { Message, Icon } from 'semantic-ui-react'

interface InterimStateOptions {
    loading: any,
    error: any,
    label: string
}

// TODO: Move this component and all references to be a component (not in the Protected folder)

const InterimStates = ({ loading, error, label }: InterimStateOptions) => {
    if (loading) {
        return (
            <ResponsiveContainer>
                <Message icon>
                    <Icon name='circle notched' loading />
                    <Message.Content>
                    <Message.Header>Just one second</Message.Header>
                    We are fetching the {label} for you.
                    </Message.Content>
                </Message>
            </ResponsiveContainer>
        )
    } else if (error) {
        return (
            <ResponsiveContainer>
                <Message negative>
                        <Message.Header>We're sorry we are having techincal issues</Message.Header>
                        <p>Please contact your administrator: Peter Heesterman</p>
                    </Message>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
            </ResponsiveContainer>
        )
    }

    return null;
}

export { InterimStates }
